function loadStyle(n) {
    var head = document.head;
    var link = document.createElement('link');

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = n;
    link.media = 'print';
    link.onload = executeStyleOnloadCallback;

    head.appendChild(link);
}

function executeStyleOnloadCallback() {
    this.media = 'all';
    this.onload = null;
}

function trustspot_tab_refresh(t, e, o, n, a, s) {
    var r = {
            method: 'popup_reviews',
            sort: e,
            pr_oldpage: s,
            pr_page: a,
            key: trustspot_key,
            cr_page: o,
            cr_oldpage: n,
            noCache: typeof noCache === 'undefined' ? 0 : noCache,
        },
        p = new XMLHttpRequest;
    p.open("POST", globalTrustSpotURL + "/api/pub/product_review_tab", !0), p.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), p.onload = function() {
        if (200 === p.status) {
            var t = JSON.parse(p.responseText);

            if (t) {
                loadStyle(globalTrustSpotURL + "/api/pub/product_widget_css/" + t[0].merchant_id + "/styles.css");
                if (document.getElementById("trustspot-tab-anchor")) {
                    var e = document.querySelector("#trustspot-tab-modal");                    
                    e.parentNode.removeChild(e), (o = document.createElement("div")).innerHTML = t[0].popupContent, document.getElementById("trustspot_tab_parent").appendChild(o), (n = document.getElementById("trustspot-tab-modal")).style.cssText = "display: flex !important;"
                } else {
                    var o;
                    (o = document.createElement("div")).id = "trustspot_tab_parent", o.innerHTML = t[0].tabAnchorContent + t[0].popupContent, document.querySelector("#PageContainer > .transition-body").appendChild(o)
                }              
                
                document.getElementById("trustspot-tab-anchor").style.cssText = "z-index: 5!important;";
              
                t[0].default_product && (globalTrustSpotTabState = "productreview"), "productreview" == globalTrustSpotTabState ? document.getElementById("trustspotTabTabDefaultProductOpen").click() : document.getElementById("trustspotTabTabDefaultCompanyOpen").click();
                var n = document.getElementById("trustspot-tab-modal"),
                    a = document.getElementById("trustspot-anchor-btn"),
                    s = document.querySelectorAll("#trustspot-tab-modal .trustspot-close")[0];
                a.onclick = function() {
                    n.style.cssText = "display: flex !important;"
                }, s.onclick = function() {
                    n.style.display = "none"
                }, window.onclick = function(t) {
                    t.target == n && (n.style.display = "none")
                }
            }
        }
    }, p.send(trustspot_tab_serialize(r)), document.getElementById("modal-review-wrapper") && (document.getElementById("modal-review-wrapper").innerHTML = `<div id='loader' class='loader-container'><img src='${globalTrustSpotURL}/assets/sources/img/ravecapture-loader.svg'></img></div>`)
}

function trustspot_tab_serialize(t, e) {
    var o, n = [];
    for (o in t)
        if (t.hasOwnProperty(o)) {
            var a = e ? e + "[" + o + "]" : o,
                s = t[o];
            if (void 0 == s) continue;
            n.push(null !== s && "object" == typeof s ? trustspot_tab_serialize(s, a) : encodeURIComponent(a) + "=" + encodeURIComponent(s))
        }
    return n.join("&")
}

function trustspotHideToggle(t, e) {
    var o = t.parentNode.parentNode.querySelectorAll("." + e);
    o[0] && o[0].classList.toggle("hide")
}

function trustspot_pr_upvote(t) {
    document.getElementById("trustspot_feedback_" + t).innerHTML = "Thanks!";
    var e = new XMLHttpRequest;
    e.onreadystatechange = function() {
        e.readyState, XMLHttpRequest.DONE
    }, e.open("GET", globalTrustSpotURL + "/api/vote/upvote_product_review/" + t, !0), e.send()
}

function trustspot_pr_downvote(t) {
    document.getElementById("trustspot_feedback_" + t).innerHTML = "Thanks!";
    var e = new XMLHttpRequest;
    e.onreadystatechange = function() {
        e.readyState, XMLHttpRequest.DONE
    }, e.open("GET", globalTrustSpotURL + "/api/vote/downvote_product_review/" + t, !0), e.send()
}

function switchTrustSpotTabTab(t, e) {
    var o, n, a;
    for (globalTrustSpotTabState = e, n = document.getElementsByClassName("tabcontent"), o = 0; o < n.length; o++) n[o].style.display = "none";
    for (a = document.getElementsByClassName("tablinks"), o = 0; o < a.length; o++) a[o].className = a[o].className.replace(" active", "");
    document.getElementById(e).style.display = "block", t.currentTarget.className += " active"
}

if ('undefined' === typeof globalTrustSpotURL) {
    globalTrustSpotURL = 'https://app.ravecapture.com';
}

if (globalTrustSpotURL.endsWith('/')) {
    globalTrustSpotURL = globalTrustSpotURL.slice(0, -1);
}

globalTrustSpotTabState = 'company';

if (document.readyState !== 'loading') {
    trustspotTabinit();
} else {
    document.addEventListener('DOMContentLoaded', trustspotTabinit);
}

function trustspotTabinit() {
    trustspot_tab_refresh('', '', 1);
    loadStyle('https://s3.amazonaws.com/trustspot-pr-widget/ts-widget-icons/widget-icons.css');
    loadStyle(globalTrustSpotURL + '/assets/sources/css/widget.css');
    loadStyle(globalTrustSpotURL + '/assets/sources/fonts/ts-stars/ts-stars.css');
    loadStyle(globalTrustSpotURL + '/assets/sources/fonts/web_fonts.css');
}